import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { DocumentaryProofState } from '@app/core/services/user/models/documentaryProofState';

@Component({
    selector: 'status-label',
    templateUrl: './status-label.component.html',
    styleUrls: ['./status-label.component.css'],
    standalone: false
})
export class StatusLabelComponent implements OnInit {

  @Input() status: string;
  @Input() type: string;
  @Input() hasTooltip = false;
  @Input() iconWithTooltip: 'exclamation' | 'question' = 'exclamation';
  @Input() tooltipContent: string;

  // green light
  SUCCESS_LIGHT = ['VERIFIED_PENDING_MODIFICATION'];
  // green
  SUCCESS = ['FINISHED', 'CLOSED', 'ACTIVE', 'TREATED', 'IN_USE', 'VERIFIED', 'FULL_PRICE', 'UNITARY', 'PROCESSED', 'OK', 'DONE', 'COMPLETED', 'VALIDATED', 'PROFILE_IN_PROGRESS', 'PAID', 'ACCEPTED', 'RECOVERED'];
  // blue
  IN_PROGRESS = ['IN_PROGRESS', 'AWAITING', 'AWAITING_REMOVAL', 'AWAITING_REMOVAL_CONFIRMATION', 'TO_REMOVE', 'STARTED', 'AWAITING_DEPOSIT', 'AWAITING_MDM_VALIDATION', 'DRAFT'];
  // blue light
  PRIMARY = ['CREATED', 'INITIALIZED', 'PLANNED', 'UNVERIFIED', 'REFUND'];
  // yellow
  WARNING = ['ASSIGNED', 'OPPOSED', 'AWAITING_VALIDATION', 'AWAITING_VALIDATION_MANUAL', 'AWAITING_VALIDATION_AUTOMATIC', 'BLOCKED', 'PROFILE_EXPIRED', 'PENDING'];
  // red
  DANGER = ['OPEN', 'NON_TREATED', 'SUSPENDED', 'CANCELLED', 'DELETED', 'TERMINATED', 'UNASSIGNED', 'REVOKED', 'UNPROCESSED', 'KO', 'REFUSED', 'SUSPENDED_FOR_PAYMENT_LIMIT', 'INACTIVE', 'EXPIRED', 'FAILED', 'ERROR'];
  // grey
  DEFAULT = ['PROFILE_PLANNED'];

  @Output() refreshAddress: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.status.previousValue && changes.status.previousValue == DocumentaryProofState.AWAITING_VALIDATION) {
      this.refreshAddress.emit('done');
    }
  }

}


